import { QuotaInfo } from "./StoragePriority";

/**
 * Monitors localStorage quota and usage.
 */
export class QuotaMonitor {
  private static readonly MAX_QUOTA = 5 * 1024 * 1024; // 5MB standard limit

  /**
   * Get estimated usage in bytes.
   */
  public static getEstimatedUsage(): number {
    if (typeof window === "undefined") return 0;

    let total = 0;
    for (const key in localStorage) {
      if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
        // approx bytes = (key.length + value.length) * 2 (UTF-16)
        total += (key.length + (localStorage.getItem(key)?.length ?? 0)) * 2;
      }
    }
    return total;
  }

  /**
   * Check if there is enough space for a new item.
   */
  public static hasSpace(bytes: number): boolean {
    const current = this.getEstimatedUsage();
    return current + bytes < this.MAX_QUOTA;
  }

  /**
   * Get detailed quota information.
   */
  public static getQuotaInfo(): QuotaInfo {
    const used = this.getEstimatedUsage();
    return {
      used,
      total: this.MAX_QUOTA,
      remaining: Math.max(0, this.MAX_QUOTA - used),
      percentUsed: Math.min(100, (used / this.MAX_QUOTA) * 100),
    };
  }
}
